import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaProgressBar from './VaProgressBar.vue'

export const VaProgressBar = withConfigTransport(_VaProgressBar)
